import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunicationsService, Communication } from '../../services/communications.service';
import { UserService } from '../../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-communication-details',
    templateUrl: './communication-details.component.html',
    styleUrls: ['./communication-details.component.sass'],
    standalone: false
})
export class CommunicationDetailsComponent implements OnInit {
  communication: Communication | null = null;
  error: string | null = null;
  isOwner = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private communicationsService: CommunicationsService,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loading = true;
    
    // Get communication from state if available
    const state = this.router.getCurrentNavigation()?.extras.state;
    if (state && state['communication']) {
      this.communication = state['communication'];
      this.checkOwnership();
      this.loading = false;
    } else {
      // Otherwise fetch from API
      const id = this.route.snapshot.params['commId'];
      if (id) {
        this.loadCommunication(parseInt(id));
      } else {
        this.loading = false;
        this.error = 'Comunicado não encontrado';
      }
    }
  }

  private loadCommunication(id: number): void {
    this.communicationsService.getCommunicationById(id).subscribe({
      next: (communication) => {
        this.communication = communication;
        this.checkOwnership();
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 400 || error.status === 401) {
          this.error = error.error?.message || 'Erro ao carregar o comunicado';
        } else {
          this.error = 'Ocorreu um erro inesperado';
        }
      }
    });
  }

  private checkOwnership(): void {
    if (this.communication) {
      this.userService.getUser().subscribe(user => {
        this.isOwner = user.username === this.communication?.authorName;
      });
    }
  }

  deleteCommunication(): void {
    if (this.communication) {
      this.communicationsService.deleteCommunication(this.communication.id).subscribe({
        next: () => {
          this.snackBar.open('Comunicado excluído com sucesso', 'Fechar', { duration: 3000 });
          this.router.navigate(['/communications']);
        },
        error: (error) => {
          this.snackBar.open('Erro ao excluir o comunicado', 'Fechar', { duration: 3000 });
        }
      });
    }
  }
}
